<template>
    <div>
        <v-checkbox label="I agree to Terms of Services" type="checkbox" v-model="submit"></v-checkbox>
        <p class="red--text" v-if="error_msg.length">
            You missed some answer(s) in the following section(s):
            <span v-for="msg in error_msg" :key="msg['id']">{{ msg }}, </span>
        </p>
        <v-btn color="teal" :disabled="isSubmit" @click="$emit('submitForm')">
            <span v-show="isSubmit">Analyzing</span>
            <span v-show="!isSubmit">Analyze</span>
        </v-btn>
    </div>
</template>
<script>
export default {
    props:['error_msg','isSubmit'],
    data(){
        return{
            submit:false
        }
    },
}
</script>

